import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'

type Status = 'loading' | 'success' | 'error'

export default function ConfirmEmail() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') ?? ''
  const [status, setStatus] = useState<Status>('loading')

  useEffect(() => {
    if (!token) {
      setStatus('error')
      return
    }
    const confirm = async () => {
      try {
        const res = await fetch('/api/auth/confirm-email', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ token }),
        })
        setStatus(res.ok ? 'success' : 'error')
      } catch {
        setStatus('error')
      }
    }
    void confirm()
  }, [token])

  const pageClass = 'min-h-screen bg-bg flex items-center justify-center p-4'
  const cardClass = 'bg-surface rounded-xl shadow-card p-10 w-full max-w-[440px] text-center'

  if (status === 'loading') {
    return (
      <div className={pageClass}>
        <div className={cardClass}>
          <div className="text-[3rem] mb-4">⏳</div>
          <h1 className="m-0 mb-3 text-[1.4rem] font-bold text-text-heading">Confirming your email…</h1>
        </div>
      </div>
    )
  }

  if (status === 'success') {
    return (
      <div className={pageClass}>
        <div className={cardClass}>
          <div className="text-[3rem] mb-4">✅</div>
          <h1 className="m-0 mb-3 text-[1.4rem] font-bold text-text-heading">Email confirmed!</h1>
          <p className="text-text-2 leading-[1.6] mb-7 text-[0.95rem]">
            Your account is active. Sign in to get started.
          </p>
          <Link
            to="/login"
            className="inline-block px-7 py-[0.7rem] bg-accent text-accent-contrast rounded no-underline font-semibold text-[0.95rem]"
          >
            Sign In
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className={pageClass}>
      <div className={cardClass}>
        <div className="text-[3rem] mb-4">❌</div>
        <h1 className="m-0 mb-3 text-[1.4rem] font-bold text-text-heading">Link expired or invalid</h1>
        <p className="text-text-2 leading-[1.6] mb-7 text-[0.95rem]">
          This confirmation link has expired or has already been used.
          Request a new one below.
        </p>
        <Link
          to="/verify-email"
          className="inline-block px-7 py-[0.7rem] bg-accent text-accent-contrast rounded no-underline font-semibold text-[0.95rem]"
        >
          Resend confirmation
        </Link>
      </div>
    </div>
  )
}
